import { DictionaryMaterial, SampleUnit } from '..';

export const emptySampleMaterial: SampleUnit = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  // @ts-expect-error
  inTray: null,
  // @ts-expect-error
  inLayer: null,
  // @ts-expect-error
  inPalet: null,
  // @ts-expect-error
  isActive: null,
};

export const emptyReccuringMaterial: DictionaryMaterial = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  // @ts-expect-error
  unitPrice: null,
  // @ts-expect-error
  billablePrice: null,
  // @ts-expect-error
  type: null,
};
